module.exports = __webpack_public_path__ + "img/logo5.0925aed7.png";